module.exports = __webpack_public_path__ + "static/media/layers.5e443440.svg";